<template>
  <a-form
    ref="formRef"
    :model="formState"
    :rules="rules"
    :label-col="{
      span: 7,
    }"
    :wrapper-col="{
      span: 17,
    }"
  >
    <a-form-item label="用户">
      <a-select
        v-model:value="formState.users"
        show-search
        :options="usersList"
        mode="multiple"
        :filter-option="filterOption"
        placeholder="点击绑定用户"
      ></a-select>
    </a-form-item>
    <a-form-item :wrapper-col="{ span: 14, offset: 5 }">
      <a-button type="primary" @click="onSubmit">提交</a-button>
      <a-button style="margin-left: 10px" @click="resetForm">重置</a-button>
    </a-form-item>
  </a-form>
</template>
<script setup>
  import { reactive, ref, defineProps, defineEmits, onMounted } from 'vue'
  import { message } from 'ant-design-vue'
  import { getRoleUser, roleBindUsers } from '@/api/system_manage/role'
  import { getUser } from '@/api/system_manage/userManage'

  const props = defineProps({ editData: Object })
  const emit = defineEmits(['submit'])
  const formRef = ref()
  const usersList = ref([])

  const defaultFormState = props.isEdit
    ? {
        roles: props.editData.roles,
      }
    : {
        roles: [],
      }
  const formState = reactive(defaultFormState)
  const rules = {}
  async function handelBind(data) {
    const res = await roleBindUsers(data)
    if (res.success) {
      message.success('绑定用户成功！')
      emit('submit')
    } else {
      message.warn('绑定用户错误：', res.message)
    }
  }
  function onSubmit() {
    formRef.value
      .validate()
      .then(() => {
        handelBind({
          roleId: props.editData.role_id,
          userIds: formState.users.toString(),
          userId: formState.users.toString(),
        })
      })
      .catch((error) => {
        console.log('绑定用户错误：', error)
      })
  }
  function resetForm() {
    formRef.value.resetFields()
  }
  function fetch() {
    getUser({ pn: 1, size: Number.MAX_SAFE_INTEGER }).then((res) => {
      if (res.success) {
        usersList.value = res.data.list.map((role) => ({
          value: role.user_id,
          label: role.user_name,
        }))
      }
    })
    getRoleUser({ roleId: props.editData.role_id }).then((res) => {
      if (res.success) {
        formState.users = res.data.map((user) => user.user_id)
      }
    })
  }
  const filterOption = (input, option) => {
    return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
  }
  onMounted(() => {
    fetch()
  })
</script>
